import { render, staticRenderFns } from "./WhitePage.vue?vue&type=template&id=8aabcc4e&"
import script from "./WhitePage.vue?vue&type=script&lang=js&"
export * from "./WhitePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports